package one.healthium.log_symptoms.ui

import one.healthium.domain.user.models.SymptomInfoModel
import one.healthium.domain.user.models.SymptomKind
import one.healthium.domain.user.models.SymptomSeverity
import one.healthium.domain.user.models.SymptomsLogModel
import androidx.compose.runtime.Immutable

@Immutable
internal data class LogSymptomsUiState(
    val loading: Boolean = false,
    val symptomInfoModels: List<SymptomInfoModel>? = null,
    val todaySymptomsLog: SymptomsLogModel? = null,
    val userSelectedSymptoms: Map<SymptomKind, SymptomSeverity> = emptyMap(),
) {
    val selectedSymptoms = userSelectedSymptoms + todaySymptomsLog?.symptoms
        ?.associate { it.kind to it.severity }
        ?.filter { userSelectedSymptoms.contains(it.key).not() }
        .orEmpty()
    val hasChanges = userSelectedSymptoms.isNotEmpty()

    val uiData: List<Any>? = symptomInfoModels?.map { symptomInfoModel ->
        SymptomUiModel(
            kind = symptomInfoModel.kind,
            severities = symptomInfoModel.severities,
            selectedSeverity = selectedSymptoms[symptomInfoModel.kind],
        )
    }
}
